<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <va-box theme="box-primary" title="Tìm kiếm">
          <div slot="content">
            <div class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Công ty</label>
              <multiselect v-model="selectedCompany" id="ajax1" label="name" track-by="code" placeholder="Nhập để tìm công ty..."
                           open-direction="bottom" :options="companies" :multiple="false" :searchable="true"
                           :loading="loadingCompany" :internal-search="false" :clear-on-select="false"
                           :close-on-select="true" :options-limit="300" :limit="2" :max-height="600" :disabled="disableCompanyField"
                           :show-no-results="false" :hide-selected="false" @search-change="debounceCompany">
              </multiselect>
            </div>
            <div class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Phòng ban</label>
              <multiselect v-model="selectedDepartment" id="ajax2" label="name" track-by="code" placeholder="Nhập để tìm phòng ban..."
                           open-direction="bottom" :options="departments" :multiple="false" :searchable="true"
                           :loading="loadingDepartment" :internal-search="false" :clear-on-select="false"
                           :close-on-select="true" :options-limit="300" :limit="2" :max-height="600"
                           @select="onSelectDepartment" @remove="onRemoveDepartment"
                           :show-no-results="false" :hide-selected="false" @search-change="debounceDepartment">
              </multiselect>
            </div>
            <div class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Chức vụ</label>
              <multiselect v-model="selectedRole" id="ajax3" label="name" track-by="code" placeholder="Nhập để tìm chức vụ..."
                           open-direction="bottom" :options="roles" :multiple="false" :searchable="true"
                           :loading="loadingRole" :internal-search="false" :clear-on-select="false"
                           :close-on-select="true" :options-limit="300" :limit="2" :max-height="600"
                           :show-no-results="false" :hide-selected="false" @search-change="debounceRole">
              </multiselect>
            </div>
            <div class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Tài khoản</label>
              <input type="text" class="form-control" v-model="filterData.username" placeholder="Nhập tài khoản ..."/>
            </div>
          </div>
          <div slot="footer">
            <div class="d-flex justify-content-between align-items-center">
              <b-button variant="success" @click="add" :disabled="!isEditable">
                <span class="glyphicon glyphicon-plus" aria-hidden="true"></span> Thêm mới
              </b-button>
              <b-button variant="warning" @click="search">
                <span class="glyphicon glyphicon-search" aria-hidden="true"></span> Tìm kiếm
              </b-button>
            </div>
          </div>
        </va-box>
      </div>

      <div class="col-md-12 col-sm-12 col-xs-12">
        <va-box theme="box-primary" title="Danh sách người dùng">
          <div slot="content">
            <b-table    bordered outlined hover responsive :busy="loading" :fields="fields" :items="items" show-empty>
              <template #table-busy>
                <div class="text-center my-2 mt-5 mb-5">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Đang tải...</strong>
                </div>
              </template>

              <template #empty="scope">
                <h4 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h4>
              </template>

              <template v-slot:cell(id)="data">
                {{genSeqId(data)}}
              </template>

              <template v-slot:cell(user_roles)="dataId">
                <Tags :tags="generateUserRoles(dataId.item)"></Tags>
              </template>
              <template v-slot:cell(status)="dataId">
                <b-form-checkbox v-model="dataId.item.status" size="lg" switch
                                 @change="updateStatus(dataId.item)"></b-form-checkbox>
              </template>

              <template v-slot:cell(actions)="dataId">
                <b-button v-b-tooltip.hover :disabled="!isEditable" title="Cập nhật" variant="warning"
                          @click="edit(dataId.item.id)"><i
                  class="fa fa-edit"/></b-button>
                <b-button variant="danger" v-b-tooltip.hover title="Xoá"
                          :disabled="!isEditable" @click="remove(dataId.item.id, dataId.item.username)"><i
                  class="fa fa-trash"/></b-button>
              </template>

            </b-table>
          </div>
          <div slot="footer" class="d-flex align-items-center justify-content-between">
            <div class="page-size-container">
              <span>Hiển thị</span>
              <b-form-select
                id="pageSize"
                v-model="pageSize"
                :options="pageSizes"
                required
              ></b-form-select>
              <span>  dòng</span>
            </div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRow"
              :per-page="pageSize"
              aria-controls="my-table"
            ></b-pagination>
          </div>
        </va-box>
      </div>
    </section>
  </div>

</template>

<script>
import VABox from 'va/widgets/VABox.vue'
import UserAPI from '../../../api/user'
import Utils from '../../../common/utils'
import Multiselect from '../../../lib/vue-multiple-select/Multiselect'
import CompanyAPI from '../../../api/company'
import DepartmentAPI from '../../../api/department'
import RoleAPI from '../../../api/role'
import {debounce} from 'lodash'
import {mapGetters} from 'vuex'
import {PERMISSION_KEY} from '../../../common/constant'
import Tags from '../../../components/Tags'

export default {
  name: 'UserList',
  components: {
    'va-box': VABox,
    Multiselect,
    Tags
  },
  data () {
    return {
      filterData: {
        company_id: null,
        role_id: [],
        username: '',
        password: '',
      },
      items: [],
      fields: [
        {
          key: 'id',
          label: 'STT'
        },
        {
          key: 'username',
          label: 'Tài khoản'
        },
        {
          key: 'user_roles',
          label: 'Phòng ban/Chức vụ'
        },
        {
          key: 'status',
          label: 'Trạng thái'
        },
        {
          key: 'actions',
          label: 'Tuỳ chọn',
          thStyle: 'width: 10%',
          class: 'actions-cell'
        }
      ],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalRow: 0,
      pageSizes: [
        {text: 100, value: 100},
        {text: 50, value: 50},
        {text: 20, value: 20},
        {text: 10, value: 10}
      ],
      loadingCompany: false,
      companies: [],
      loadingDepartment: false,
      departments: [],
      loadingRole: false,
      roles: [],
      selectedCompany: null,
      selectedDepartment: null,
      selectedRole: null,
      debounceCompany: null,
      debounceDepartment: null,
      debounceRole: null,
      disableCompanyField: false,
      isEditable: true,
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'editPermission'
    ])
  },
  created () {
    this.debounceCompany = debounce(this.filterCompany.bind(this), 500)
    this.debounceDepartment = debounce(this.filterDepartment.bind(this), 500)
    this.debounceRole = debounce(this.filterRole.bind(this), 500)
  },
  mounted () {
    this.initCompany()
    this.filter()
    this.filterDepartment()
    this.filterRole()
    this.isEditable = this.hasEditPermission()
  },
  methods: {
    genSeqId (data) {
      return data.index + (this.currentPage - 1) * this.pageSize + 1
    },
    hasEditPermission () {
      return Utils.isAdminUser(this.userInfo) || this.editPermission.includes(PERMISSION_KEY.USER_MANAGEMENT)
    },
    initCompany () {
      let company = Utils.getCompanyByUserInfo(this.userInfo)
      if (company) {
        this.disableCompanyField = true
        this.selectedCompany = {name: company.name, code: company.id}
      }
    },
    calculateFilterData () {
      this.filterData.company_id = this.selectedCompany ? this.selectedCompany.code : null
      this.filterData.department_id = this.selectedDepartment ? this.selectedDepartment.code : null
      this.filterData.role_id = this.selectedRole ? this.selectedRole.code : null

      const companyId = this.$route.query.company_id
      if (this.filterData.company_id == null && companyId) {
        this.filterData.company_id = companyId
      }
      const departmentId = this.$route.query.department_id
      if (this.filterData.department_id == null && departmentId) {
        this.filterData.department_id = departmentId
      }
      const roleId = this.$route.query.role_id
      if (this.filterData.role_id == null && roleId) {
        this.filterData.role_id = roleId
      }
    },
    filter () {
      if (this.loading) {
        return
      }
      this.calculateFilterData()
      if (this.filterData.company_id == null) {
        this.items = []
        this.loading = false
        return
      }
      this.loading = true

      const data = {...this.filterData}
      if (data.department_id == null) {
        delete data.department_id
      }
      if (data.role_id == null) {
        delete data.role_id
      }

      UserAPI.filter(data, this.currentPage - 1, this.pageSize).then(res => {
        this.loading = false
        this.items = res.data.data.records
        this.totalRow = res.data.data.total
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    search () {
      this.filter()
    },
    add () {
      this.$router.push('/user/add')
    },
    edit (id) {
      this.$router.push('/user/edit/' + id)
    },
    remove (id, name) {
      if (id) {
        this.$bvModal.msgBoxConfirm('Xóa ' + name + '. Bạn có chắc không?', {
          title: false,
          buttonSize: 'sm',
          centered: true,
          size: 'sm',
          footerClass: 'p-2'
        }).then(res => {
          if (res) {
            UserAPI.remove(id)
            Utils.successToast(this.$bvToast)
            this.filter()
          }
        })
      }
    },
    filterCompany (query) {
      this.loadingCompany = true
      CompanyAPI.findByName(query, 0, 20).then(res => {
        this.companies = res.data.data.records.map(item => {
          return {'name': item.name, 'code': item.id}
        })
        this.loadingCompany = false
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingCompany = false
      })
    },
    filterDepartment (query) {
      this.loadingDepartment = true
      if (this.selectedCompany == null) {
        this.loadingCompany = false
        return
      }
      const filterData = {
        company_id: this.selectedCompany.code,
        department_name: query
      }
      DepartmentAPI.filter(filterData, 0, 20).then(res => {
        this.departments = res.data.data.records.map(item => {
          return {'name': item.department_name, 'code': item.id}
        })
        this.loadingDepartment = false
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingDepartment = false
      })
    },
    filterRole (query) {
      this.loadingRole = true
      if (this.selectedCompany == null || this.selectedDepartment == null) {
        this.loadingRole = false
        return
      }
      const filterData = {
        company_id: this.selectedCompany.code,
        department_id: this.selectedDepartment.code,
        role_name: query,
        role_id: null,
      }
      RoleAPI.filter(filterData, 0, 20).then(res => {
        this.roles = res.data.data.records.map(item => {
          return {'name': item.role_name, 'code': item.id}
        })
        this.loadingRole = false
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingRole = false
      })
    },
    generateUserRoles (item) {
      return item.user_roles.map(user_role => {
        if (user_role.role) {
          return user_role.department.department_name + ' - ' + user_role.role.role_name
        }
        return 'Admin'
      })
    },
    updateStatus (data) {
      const companyId = data.user_roles[0].company.id
      UserAPI.update({id: data.id, company_id: companyId, status: data.status}).then(res => {
        Utils.successToast(this.$bvToast)
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
      })
    },
    onSelectDepartment (event) {
      this.selectedDepartment = {
        code: event.code,
        name: event.name
      }
      this.filterRole()
      this.selectedRole = null
    },
    onRemoveDepartment (event) {
      this.selectedDepartment = null
      this.roles = []
      this.selectedRole = null
    }
  },
  watch: {
    currentPage: {
      handler: function () {
        this.filter()
      }
    },
    pageSize: {
      handler: function () {
        this.filter()
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user_management/user/UserList.vue